import { mockDelegationData } from "@/entities";
import { mockUserClientSubclientServicepointData } from "../servicepoint/servicepoint.mock";
import { UserClientSubclient } from "./subclient";
import { IUserClientSubclient, IUserClientSubclientData } from "./subclient.types";

export const mockUserClientSubclientData = (): IUserClientSubclientData[] => [
  {
    id: 3,
    oidSol: "641399e7-b066-4bcf-8073-398d6345ef9a",
    codeSol: "0087",
    idSmartcash: "0087",
    uniqueCode: "",
    description: "Rio - Suc. 087 Centro",
    active: true,
    delegation: mockDelegationData()[1],
    servicepoints: [mockUserClientSubclientServicepointData()[0]],
  },
  {
    id: 7,
    oidSol: "74e77b9a-9e4c-11e7-b6a4-a9c1c80341f0",
    codeSol: "90013",
    idSmartcash: "0013",
    uniqueCode: "",
    description: "E.D.E.T. - Avellaneda",
    active: true,
    delegation: mockDelegationData()[0],
    servicepoints: [mockUserClientSubclientServicepointData()[1]],
  },
];

export const mockUserClientSubclient = (
  data: IUserClientSubclientData[] = mockUserClientSubclientData()
): IUserClientSubclient[] => data.map((item) => new UserClientSubclient(item));
